import { API_URLS } from '@helpers/api';
import { createAsyncThunk } from '@reduxjs/toolkit';
export const createPinboardItem = createAsyncThunk('pinboards/items/create', async (params) => {
    const response = await fetch(API_URLS.createPinboardItem, {
        body: JSON.stringify(params),
        headers: { 'Content-Type': 'application/json' },
        method: 'post',
    });
    return (await response.json());
});
